import { Popover } from '@chakra-ui/react';
import { DateValue } from '@internationalized/date';
import { prettyDate } from '@pelicargo/utils';
import { DatePickerCalendar, DatePickerStatic } from '@saas-ui/date-picker';

import { useFilterState } from '../../hooks/useFilterState';
import { FilterPopoverButton, FilterPopoverContent } from '../FilterPopoverButton';

const convertCalendarDate = (value: DateValue | null) => {
  return new Date(value!.year, value!.month - 1, value!.day, 23, 59, 59, 999);
};

type Props = {
  // TODO(clayton): fix typings
  value?: Date | string | string[] | any;
  onChange: (value: any) => void;
};

export const DateFilterPopover = ({ value, onChange }: Props) => {
  const state = useFilterState({
    defaultValue: value,
    onSubmit: onChange,
  });

  const handleDateChange = (nextDate: DateValue | null) => {
    if (!nextDate) onChange(null);
    state.onChange(convertCalendarDate(nextDate));
  };

  return (
    <Popover placement="bottom-start">
      <FilterPopoverButton label={prettyDate(value)} />
      <FilterPopoverContent onClickApply={state.onSubmit} onClickCancel={state.onReset}>
        <DatePickerStatic colorScheme="primary" granularity="day" onChange={handleDateChange}>
          <DatePickerCalendar
            w="full"
            sx={{
              table: { width: '100%' },
              svg: { height: 4, width: 4 },
            }}
          />
        </DatePickerStatic>
      </FilterPopoverContent>
    </Popover>
  );
};
